import PropTypes from "prop-types";
import React, { createContext } from "react";

export const AnimationContext = createContext({
  enableReflowAnimations: true,
});

AnimationContext.displayName = "AnimationContext";

/**
 * AnimationProvider gives components access to the current status of reflow
 * animations which may alter layout on the page. The primary purpose of
 * disabling these animations is to limit CLS as the page gathers layout
 * information. This can be used to limit size and position animations as
 * WCM content is loaded for example.
 */
export const AnimationProvider = (props) => {
  const { children, enableReflowAnimations = true } = props;

  return (
    <AnimationContext.Provider value={{ enableReflowAnimations }}>
      {children}
    </AnimationContext.Provider>
  );
};

AnimationProvider.displayName = "AnimationProvider";

AnimationProvider.propTypes = {
  /** Content that will be rendered. */
  children: PropTypes.node.isRequired,

  /** Determines whether animations that can impact page layout should be enabled */
  enableReflowAnimations: PropTypes.bool,
};
